import { REMOVE_DUPLICATE_FIELD_ERROR, SET_DUPLICATE_FIELD_ERROR } from '../types';

const initialState = {
  duplicateFields: [],
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SET_DUPLICATE_FIELD_ERROR:
      return {
        ...state,
        duplicateFields: [...state.duplicateFields, payload.id],
      };
    case REMOVE_DUPLICATE_FIELD_ERROR:
      return {
        ...state,
        duplicateFields: state.duplicateFields.filter((id) => id !== payload.id),
      };
    default:
      return state;
  }
}
